package ir.alirezaivaz.finglish.utils

import androidx.compose.material3.ColorScheme
import androidx.compose.runtime.Composable
import ir.alirezaivaz.finglish.dto.Theme
import ir.alirezaivaz.finglish.dto.isDarkMode
import ir.alirezaivaz.finglish.ui.theme.darkScheme
import ir.alirezaivaz.finglish.ui.theme.lightScheme
import kotlin.js.ExperimentalWasmJsInterop
import kotlin.js.js

actual object Utils {
    actual fun getVersionName(): String = "1.0.0-beta"

    @OptIn(ExperimentalWasmJsInterop::class)
    actual fun isShareSupported(): Boolean = js("navigator.share !== undefined")

    actual fun isDynamicColorsSupported(): Boolean = false

    actual fun isSystemNightModeSupported(): Boolean = true

    @OptIn(ExperimentalWasmJsInterop::class)
    actual fun share(text: String): Boolean = js("""
        navigator.share({
            text: text
        })
    """)

    actual fun applyTheme(theme: Theme) {}

    @Composable
    actual fun getColorScheme(theme: Theme, isDynamicColors: Boolean): ColorScheme {
        return if (theme.isDarkMode()) {
            darkScheme
        } else {
            lightScheme
        }
    }
}
